
// Get all deliveries
export const getDeliveriesStart =()=>({
    type: "GET_DELIVERIES_START",
});
export const getDeliveriesSuccess =(deliveries)=>({
    type: "GET_DELIVERIES_SUCCESS",
    payload: deliveries,
});
export const getDeliveriesFailure =(error)=>({
    type: "GET_DELIVERIES_FAILURE",
    payload: error,
});


// Add one delivery
export const addDeliveryStart =()=>({
    type: "ADD_DELIVERY_START",
});
export const addDeliverySuccess =(delivery)=>({
    type: "ADD_DELIVERY_SUCCESS",
    payload: delivery,
});
export const addDeliveryFailure =(error)=>({
    type: "ADD_DELIVERY_FAILURE",
    payload: error,
});

// Update one delivery
export const updateDeliveryStart =()=>({
    type: "UPDATE_DELIVERY_START",
});
export const updateDeliverySuccess =(delivery)=>({
    type: "UPDATE_DELIVERY_SUCCESS",
    payload: delivery,
});
export const updateDeliveryFailure =(error)=>({
    type: "UPDATE_DELIVERY_FAILURE",
    payload: error,
});


// Activate one delivery
export const activateDeliveryStart =()=>({
    type: "ACTIVATE_DELIVERY_START",
});
export const activateDeliverySuccess =(delivery)=>({
    type: "ACTIVATE_DELIVERY_SUCCESS",
    payload: delivery,
});
export const activateDeliveryFailure =(error)=>({
    type: "ACTIVATE_DELIVERY_FAILURE",
    payload: error,
});


// Get all Transporteurs
export const getTransporteursSuccess =(transporteurs)=>({
    type: "GET_TRANSPORTEURS_SUCCESS",
    payload: transporteurs,
});

// Get all Livreur
export const getLivreurSuccess =(livreurs)=>({
    type: "GET_LIVREURS_SUCCESS",
    payload: livreurs,
});